import { render } from "./NextEvents.vue?vue&type=template&id=48dec429&scoped=true"
import script from "./NextEvents.vue?vue&type=script&lang=js"
export * from "./NextEvents.vue?vue&type=script&lang=js"

import "./NextEvents.vue?vue&type=style&index=0&id=48dec429&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dec429"]])

export default __exports__